import { FC } from 'react';
import './IFrame.scss';
import { isDntEnabled } from '@utils/dnt.ts';

export interface IframeProps {
  src: string;
  width: number;
  height: number;
  border: boolean;
  title: string;
  containerClass: string;
  allowPopups: boolean;
  allowScripts: boolean;
  allowTopNavigationByActivation: boolean;
  notForDnt?: boolean;
}

const IFrame: FC<IframeProps> = ({
  src,
  width,
  height,
  title,
  border,
  containerClass,
  allowPopups,
  allowScripts,
  allowTopNavigationByActivation,
  notForDnt = false,
}) => {
  if (!notForDnt && isDntEnabled()) {
    return null;
  }
  let sandbox = `allow-forms allow-same-origin`;
  sandbox = `${sandbox}${allowPopups ? ' allow-popups allow-popups-to-escape-sandbox' : ''}`;
  sandbox = `${sandbox}${allowScripts ? ' allow-scripts' : ''}`;
  sandbox = `${sandbox}${allowTopNavigationByActivation ? ' allow-top-navigation-by-user-activation' : ''}`;
  return (
    <div className={`iframe--container ${containerClass || ''}`}>
      <iframe
        className={`iframe${!border ? ` iframe-no-border` : ''}`}
        src={src}
        height={height}
        width={width ? width : '100%'}
        title={title}
        sandbox={sandbox}
      />
    </div>
  );
};

export default IFrame;
